import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const registrationApi = (data) =>
    Promise.resolve(axios.post(endpoints.registration, data));
